// extracted by mini-css-extract-plugin
module.exports = {"nextArrow":"sliderArrow_nextArrow__2QdgQ","prevArrow":"sliderArrow_prevArrow__PUarI"};